import { mount } from 'svelte';
import App from './components/App.svelte';
import { PAGE_TITLE } from './lib/config';
import './app.css';

document.title = PAGE_TITLE;

const target = document.getElementById('app');
if (!target) {
  throw new Error('missing #app mount point');
}

mount(App, { target });
